<template>
  <div>
    <ElDropdown trigger="click">
      <div class="p-1">
        <WcTooltip :text="$t('homePage.inbox.sort')">
          <WcIconDataTransfer />
        </WcTooltip>
      </div>
      <ElDropdownMenu>
        <div class="p-2">
          <div class="flex justify-between gap-5 align-items-center px-2">
            <WcTypography :title="$t('homePage.inbox.ordering')" weight="500" size="xs"  color="rgb(4,4,4,0.77)"/>
            <div class="text-xs">
              <ElSelect v-model="query.order" @input="handleChange" value="">
                <ElOption value="DESC" :label="$t('homePage.inbox.newest')"/>
                <ElOption value="ASC" :label="$t('homePage.inbox.oldest')"/>
              </ElSelect>
            </div>
          </div>
        </div>
      </ElDropdownMenu>
    </ElDropdown>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'
import WcIconFilter from '@/components/UILibrary/Icons/WcIconFilter.vue'
import WcTypography from '@/components/UILibrary/Typography/WcTypography.vue'
import { InboxQuery } from '@/views/home-page/inbox/models/inbox.entity'
import WcTooltip from '@/components/UILibrary/WcTooltip.vue'
import WcIconDataTransfer from '@/components/UILibrary/Icons/WcIconDataTransfer.vue'

@Component({
  components: { WcIconDataTransfer, WcTooltip, WcTypography, WcIconFilter }
})
export default class PrimaryFilter extends Vue {
    @Prop({ required: true }) query!: InboxQuery

    handleChange(): void {
      this.$emit('handle-change')
    }
}
</script>
<style scoped>

</style>
